import { render, staticRenderFns } from "./installPartition.vue?vue&type=template&id=74da600b&scoped=true&"
import script from "./installPartition.vue?vue&type=script&lang=js&"
export * from "./installPartition.vue?vue&type=script&lang=js&"
import style0 from "./installPartition.vue?vue&type=style&index=0&id=74da600b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74da600b",
  null
  
)

export default component.exports